const defaultTenant = "Vistaprint";

export { defaultTenant };
//# sourceMappingURL=src-constants-global.js.map
